export default __webpack_public_path__ + "static/media/ring.55c6478f.svg";